<template>
    <div class="dasiy-form-control">
        <label class="dasiy-label">
            <span class="dasiy-label-text">{{ label }}</span>
        </label>
        <input v-bind="$attrs" type="text" :placeholder="`Please fill ${label}`" class="dasiy-input-bordered dasiy-input dasiy-input-md w-full" />
    </div>
</template>

<script lang="ts">
export default defineComponent({
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: "",
        },
    },
});
</script>
